"use client"

/**
 * AppProviders — initializes auth and API client for all routes.
 *
 * Place inside JotaiContainer in the root layout. This ensures:
 * - useAuthInit() fetches user state ONCE per app load and stores it
 *   in Jotai atoms (subsequent consumers read via useSimpleAuth).
 * - useNeoClient() initializes the API client (NeoNodeBase, QueryBuilderBase)
 *
 * Important: this is the ONLY place useAuthInit() should be called.
 * Other components should use useSimpleAuth() (read-only) so we don't
 * fan out auth fetches per-consumer-per-mount — under Suspense thrash
 * on initial load that previously multiplied into dozens of duplicate
 * /auth/config + /auth/user requests (~76 in 12s before this refactor).
 */

import { useAuthInit } from '@sourcepilot/ui/shell/auth/use-simple-auth';
import { useNeoClient } from '@sourcepilot/ui/framework/data/hooks/use-neo-client';

export function AppProviders({ children }: { children: React.ReactNode }) {
  // Initialize auth state (single fetch per app load, stored in Jotai atoms)
  useAuthInit();

  // Initialize API client (sets static fetch on NeoNodeBase/QueryBuilderBase)
  useNeoClient();

  return <>{children}</>;
}
